import { omit } from "lodash";
import { WrappedError } from "@wellth/networking";
import errorAction from "./error";

export default (apolloError: WrappedError) =>
  errorAction({
    ...omit(apolloError, "type"),
    suppress: apolloError.type === "network",
  });
